import SocialLink from "../../SocialLink";

export const RichTextSocialLink = ({
  type,
  url,
}: Partial<SocialLinkElement>) => {
  return <SocialLink type={type || "linkedin"} url={url || "/"}></SocialLink>;
};
